import { useAuth0 } from '@auth0/auth0-react';
import { useFeatureGate } from '@statsig/react-bindings';
import { useCallback } from 'react';

import { LoginExperience } from '../../../auth/types';
import { clientUserAuthGate } from '../../../statsig/gates';

export function useClientLogin(): {
  handleLogin: () => void;
  isAuthenticated: boolean;
  isClientAuthEnabled: boolean;
} {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const handleLogin = useCallback(() => {
    loginWithRedirect({
      authorizationParams: {
        target_login_experience: LoginExperience.CLIENT,
      },
      appState: { returnTo: location.pathname },
    });
  }, [loginWithRedirect]);

  const { value: isClientAuthEnabled } = useFeatureGate(clientUserAuthGate);

  return { handleLogin, isAuthenticated, isClientAuthEnabled };
}
